import AvailabilityBadge from './availabilityBadge';

export default AvailabilityBadge;
